import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiDifficultyLevels extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}